import { useState } from 'react';

import { Modal } from '@iwoca/orion';

import loaderGif from './iwoca-loader.gif';
import { useDelayedVisibility } from '../../hooks/useDelayedVisibility';

export const LOADING_MODAL_TEST_ID = 'src-components-loading-modal';

const DEFAULT_VISIBILITY =
  import.meta.env.MODE === 'test'
    ? { showDelay: 0, minDuration: 0 }
    : { showDelay: 200, minDuration: 1_000 };

export const LoadingModal = ({
  isOpen,
  dismissable = false,
  onClose,
  title,
  subText,
  tip,
  showDelay = DEFAULT_VISIBILITY.showDelay,
  minDuration = DEFAULT_VISIBILITY.minDuration,
}: {
  isOpen: boolean;
  dismissable?: boolean;
  onClose?: () => void;
  title: string;
  subText: string;
  tip?: string;
  showDelay?: number;
  minDuration?: number;
}) => {
  const [dismissed, setDismissed] = useState(false);
  const visible = useDelayedVisibility(isOpen && !dismissed, {
    showDelay,
    minDuration,
  });

  return (
    <Modal
      isOpen={visible}
      onClose={() => {
        if (onClose) onClose();
        if (dismissable) setDismissed(true);
      }}
      title={title}
      closeIcon={dismissable}
      data-testid={LOADING_MODAL_TEST_ID}
    >
      <div className="flex flex-col gap-l">
        <div className="flex items-center justify-center">
          <img
            src={loaderGif}
            alt=""
            width={185}
            height={185}
            decoding="async"
          />
        </div>
        <div className="text-l font-reg">{subText}</div>
        {tip && <div className="mb-l text-s font-med">💡 {tip}</div>}
      </div>
    </Modal>
  );
};
